import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/L_IFS_SEC_FORM_17_Q_02MAY2024.pdf';

export default function L() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>L. IFS SEC FORM 17 Q 02MAY2024</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
